import React from "react";
import { Link } from "react-router-dom";
import "./About.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";
import { MdPeopleAlt } from "react-icons/md";
import { RiMapPin2Fill } from "react-icons/ri";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLeaf,
  faMicrochip,
  faUsers,
  faGlobeAsia,
} from "@fortawesome/free-solid-svg-icons";

function About() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="about-page">
      {/* Section 1: Hero */}
      <section
        id="company-profile"
        className="company-profile text-center"
        data-aos="fade-up"
      >
        <h2 className="profile-title">公司简介</h2>
        <p className="profile-subtitle">
        了解我们对承诺与工艺的坚持
        </p>
      </section>

      {/* Section 2: Establishment */}
      <section
        className="established-section position-relative"
        data-aos="fade-up"
      >
        {/* Background image */}
        <img
          src="/images/BG - About Us.png"
          alt="Establishment"
          className="establishment-bg"
        />

        <div className="container d-flex flex-column flex-md-row align-items-start position-relative">
          {/* Year Info */}
          <div className="year-banner text-center text-md-start flex-shrink-0 me-md-4 mb-4 mb-md-0">
            <h5 className="fw-bold official-text">年正式成立</h5>
            <h1 className="display-1 fw-bold">2021</h1>
          </div>

          {/* Text Box */}
          <div className="established-text-cn text-white">
            <p>
              <strong>
              PT Foremost Mebel Indonesia 是一家总部位于印度尼西亚的家具和 OEM 制造商。
              </strong>{" "}
              我们不仅是全球客户值得信赖的 OEM 合作伙伴，也自豪地开发、制造并销售我们自有品牌的床垫、枕头及舒适型家具。
            </p>
            <p>
            我们的专长涵盖各种定制家具与组件，包括床垫、枕头、泡棉类产品及其他根据客户设计、材料或功能需求定制的多样产品。我们提供全面的 OEM 服务——涵盖产品开发、样品制作、材料采购、大规模生产以及严格的质量控制——帮助企业建立自己的品牌系列。
            </p>
            <p>
            我们专注于一致性、定制化及准时交付，不仅支持客户，也发展我们自有品牌，提供贴合市场需求的成品家具解决方案。
            </p>
          </div>
        </div>
      </section>

      {/* Section 3: Vision & Mission */}
      <section className="vision-mission-section" data-aos="fade-right">
        <div className="row g-4">
          {/* Vision */}
          <div className="col-md-6">
            <div className="card-box hover-card">
              <div className="face face1">
                <div className="content">
                  <h3>我们的愿景</h3>
                  <ul>
                    <li>
                    成为印尼家具制造行业值得信赖的领导者，以提供高质量、定制化的OEM解决方案而闻名，助力客户品牌在本地及未来走向国际。
                    </li>
                    <li>
                    通过将可持续性与创新融入生产流程，推动负责任的制造实践。
                    </li>
                  </ul>
                </div>
              </div>
              <div className="face face2">
                <h2>愿景</h2>
              </div>
            </div>
          </div>

          {/* Mission */}
          <div className="col-md-6">
            <div className="card-box hover-card">
              <div className="face face1">
                <div className="content">
                  <h3>我们的使命</h3>
                  <ul>
                    <li>
                    提供可靠、实惠且量身定制的家具解决方案，体现客户的设计和品牌目标。
                    </li>
                    <li>
                    在整个制造周期中保持卓越——从产品开发和打样到采购、生产和质量控制。
                    </li>
                    <li>
                    通过透明、稳定和客户满意度建立持久的合作关系。
                    </li>
                    <li>
                    通过采用环保做法并为未来的出口机会做好准备，助力印尼家具行业的可持续发展。
                    </li>
                  </ul>
                </div>
              </div>
              <div className="face face2">
                <h2>使命</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Goal Section */}
      <section className="goals-section" data-aos="fade-in">
        <h3 className="section-title">我们的目标</h3>
        <div className="goals-container">
          <div className="goal-card">
            <FaCheckCircle className="goal-icon" />
            <h5>提升产品质量与一致性</h5>
            <p>
            持续改进制造标准，提供耐用、实用且具有美感的家具，满足客户期望。
            </p>
          </div>

          <div className="goal-card">
            <MdPeopleAlt className="goal-icon" />
            <h5>加强以客户为中心的解决方案</h5>
            <p>
            开发灵活的 OEM 服务，适应每位客户在设计、品牌和市场方面的需求。
            </p>
          </div>

          <div className="goal-card">
            <RiMapPin2Fill className="goal-icon" />
            <h5>扩大本地市场影响力</h5>
            <p>
            通过与本地零售商、项目承包商和酒店客户建立合作关系，增强我们在印尼重点区域的市场存在。
            </p>
          </div>
        </div>
      </section>

      {/* Section 5: Extended Goals with Diamond Images */}
      <section className="extended-goals-section py-5" data-aos="fade-down">

        <div className="container">
          <div className="row g-4">
            {/* Card 1 */}
            <div className="col-12 col-md-6">
              <div className="goal-card h-100">
                <div className="goal-icon-box">
                  <FontAwesomeIcon icon={faLeaf} className="goal-icon" />
                </div>
                <div className="goal-text">
                  <br />
                  <h5>推动可持续制造</h5>
                  <p>
                  整合环保材料与高效生产方式，以减少环境影响并支持绿色发展倡议。
                  </p>
                </div>
              </div>
            </div>
            
            {/* Card 2 */}
            <div className="col-12 col-md-6">
              <div className="goal-card h-100">
                <div className="goal-icon-box">
                  <FontAwesomeIcon
                    icon={faMicrochip}
                    className="goal-icon"
                  />
                </div>
                <div className="goal-text">
                  <br />
                  <h5>投资于创新与技术</h5>
                  <p>
                  采用现代制造工具、设计软件和流程自动化，以提升生产效率和定制能力。
                  </p>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="col-12 col-md-6">
              <div className="goal-card h-100">
                <div className="goal-icon-box">
                  <FontAwesomeIcon icon={faUsers} className="goal-icon" />
                </div>
                <div className="goal-text">
                  <br />
                  <h5>培养技术熟练且积极进取的员工队伍</h5>
                  <p>
                  提供持续培训和职业发展机会，营造一个安全、高效、有活力的工作环境。
                  </p>
                </div>
              </div>
            </div>

            {/* Card 4 */}
            <div className="col-12 col-md-6">
              <div className="goal-card h-100">
                <div className="goal-icon-box">
                  <FontAwesomeIcon
                    icon={faGlobeAsia}
                    className="goal-icon"
                  />
                </div>
                <div className="goal-text">
                  <br />
                  <h5>为未来的国际增长奠定基础</h5>
                  <p>
                  使产品标准与全球市场预期保持一致，并建立战略性的出口准备。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>

      {/* Section 6 */}
      <section
        className="about-hero d-flex flex-column justify-content-center align-items-center text-white text-center"
        data-aos="zoom-out"
      >
        <h1>原始制造者，OEM合作伙伴。</h1>
        <p>
        凭借灵活的最小起订量、快速的生产周期和对品质的承诺，
          <br />
          我们高效且可靠地将您的创意变为现实。
        </p>
      </section>

      {/* FOOTER SECTION */}
      <div
        className="footer-section text-white section-fade"
        style={{ backgroundColor: "#754c24" }}
        data-aos="fade-up"
      >
        <div className="container-fluid px-0">
          <div className="row g-0">
            <div
              className="col-md-3 d-flex align-items-center justify-content-center"
              style={{ backgroundColor: "#5c3e1c", position: "relative" }}
            >
              <img
                src="/images/dotwall.jpg"
                alt="FORMEB Logo"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  zIndex: 0,
                }}
              />
              <div
                className="text-center py-4 px-3"
                style={{ zIndex: 1, position: "relative" }}
              >
                <img
                  src="/images/logo.png"
                  alt="FORMEB Logo"
                  style={{ maxWidth: "350px" }}
                />
                <p className="footer-tagline mt-2 fst-italic text-white">
                  Foremost Living Style
                </p>
              </div>
            </div>

            <div className="col-md-9 px-4 py-5">
              <div className="row text-start">
                <div className="col-md-4 mb-4 mb-md-0 border-end border-light px-4">
                  <h5 className="footer-title text-white">产品</h5>
                  <ul className="list-unstyled footer-links">
                    <li>床垫</li>
                    <li>枕头</li>
                    <li>泡沫</li>
                  </ul>
                </div>
                <div className="col-md-4 mb-4 mb-md-0 border-end border-light px-4">
                  <h5 className="footer-title text-white">关于我们</h5>
                  <ul className="list-unstyled footer-links">
                    <li>
                      <Link
                        to="/about-cn#company-profile"
                        className="text-white text-decoration-none"
                      >
                        公司简介
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products#services"
                        className="text-white text-decoration-none"
                      >
                        服务
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products#services"
                        className="text-white text-decoration-none"
                      >
                        项目亮点
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products#services"
                        className="text-white text-decoration-none"
                      >
                        职业
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4 ps-4">
                  <h5 className="footer-title text-white">联系方式</h5>
                  <ul className="list-unstyled footer-links">
                    <li>
                      <Link
                        to="/contact-cn"
                        className="text-white text-decoration-none"
                      >
                        联系方式
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/contact-cn"
                        className="text-white text-decoration-none"
                      >
                        我们的位置
                      </Link>
                    </li>
                    <li className="mt-2">
                      <a
                        href="mailto:xxxxxx@gmail.com"
                        className="text-white me-3"
                      >
                        <i className="bi bi-envelope"></i>
                      </a>
                      <a
                        href="https://www.linkedin.com/company/pt-foremost-mebel-indonesia/posts/?feedView=all"
                        className="text-white"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="bi bi-linkedin"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <hr className="text-light my-4" />
              <div className="row">
                <div className="col-md-6">
                  <p className="footer-email fw-bold text-white">
                    contact@formeb.id
                  </p>
                  <address className="footer-address text-white mt-2">
                    PT. FOREMOST MEBEL INDONESIA
                    <br />
                    Jl. Gemilang, RT.002/RW.003, Tlajung Udik,
                    <br />
                    Kec. Gn. Putri, Kabupaten Bogor, Jawa Barat 16963
                  </address>
                </div>
              </div>
              <div className="d-flex justify-content-end mt-4 small text-light">
                ©2025 Foremost Mebel Indonesia. All Rights Reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
